import React, { useContext } from "react";
import AuthContext from "../../context/userAuth.context";
import ExportVideosTable from "../../Utils/ExportVideosTable";

// "My Videos" tab on the dashboard. Progress updates live while a video is exporting.
export const MyVideos = (props) => {
  const { authenticationData } = useContext(AuthContext);

  return (
    <>
      <div className="Note">
        Progress updates automatically. You can keep working while your video exports.
      </div>
      <ExportVideosTable apiBaseURL={authenticationData.ApiBaseURL} setDeafultLoader={props.setDeafultLoader} />
    </>
  );
};

export default MyVideos;
